module.exports = __webpack_public_path__ + "img/c51f94edb038a2fa2a57f1f86a039fba.svg";